<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

/* 全局样式重置，移除默认滚动条 */
html, body {
  margin: 0;
  padding: 0;
  overflow: hidden;
}

/* 登录页面和管理页面允许滚动 */
html.admin-mode, html.admin-mode body {
  overflow: auto;
}
</style>
